import { moment } from "../date";
import type { Tables } from "../types/database.types";

/**
 * Find the employment whose `[validFrom, validTo]` span contains the
 * given date. Open-ended employments (`validTo` null) cover every
 * date on or after `validFrom` — including future dates, so that
 * planned/booked future absences resolve correctly. Assumes
 * employments do not overlap.
 *
 * @param employments - Candidate employment records to search.
 * @param date - The date (DB string format) to resolve against.
 * @returns The matching employment, or `null` if none covers the date.
 */
export function getEmploymentForDate(employments: Array<Tables<"employments">>, date: string) {
	const dateMoment = moment(date);

	for (const employment of employments) {
		if (employment.validTo) {
			const isWithin = dateMoment.isBetween(
				employment.validFrom,
				employment.validTo,
				"dates",
				"[]",
			);
			if (isWithin) return employment;
		} else {
			const isAfterStart = dateMoment.isSameOrAfter(employment.validFrom, "dates");
			if (isAfterStart) return employment;
		}
	}

	return null;
}
